import React from 'react';

import { Container } from './styles';

function Main({ children }) {
  return <Container>{children}</Container>;
}

export default Main;
